<template>
  <div>
    <div class="px-5 mb-5">
      <h3 class="headline" v-if="!editando">{{ value.nome }}</h3>
      <v-text-field
        v-else
        class="mt-1"
        dense
        outlined
        label="Nome"
        v-model="value.nome"
        maxlength="50"
      />
      <p v-if="value.observacoes !== '' && !editando">
        {{ value.observacoes }}
      </p>
      <v-textarea
        v-else-if="editando"
        auto-grow
        dense
        outlined
        label="Observações"
        v-model="value.observacoes"
      />
      <div v-if="!editando" class="mt-2">
        <v-chip
          small
          class="mr-2"
          v-for="(tipo, i) in value.tipos"
          :key="`contato-${i}`"
        >
          {{ strTipo(tipo) }}
        </v-chip>
      </div>
      <v-select
        v-else
        v-model="value.tipos"
        outlined
        dense
        chips
        deletable-chips
        small-chips
        eager
        multiple
        :items="tiposContato"
        label="Tipos"
        hint="Identifique as finalidades deste contato"
        persistent-hint
      />
    </div>
    <template v-if="value.telefones.length > 0 || editando">
      <v-divider />
      <telefone-lista v-model="value.telefones" :editando="editando" />
    </template>
    <template v-if="value.emails.length > 0 || editando">
      <v-divider />
      <email-lista v-model="value.emails" :editando="editando" />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TelefoneLista from "./TelefoneLista";
import EmailLista from "./EmailLista";
export default {
  components: { TelefoneLista, EmailLista },
  props: ["value", "editando"],
  computed: mapState({
    tiposContato: (state) => state.contato.tiposContato,
  }),
  methods: {
    strTipo(tipo) {
      return this.$store.getters["contato/strTipo"](tipo);
    },
  },
};
</script>
